<template>
    <div class="not-found">
        <Header/>
        <div class="content">
            <p class="is-lato">
                <span>404</span>
                <span>Page not found</span>
            </p>
        </div>
    </div>
</template>

<script>
import Header from '@/components/common/Header'
export default {
    name: 'NotFound',
    components: { Header },
    methods: {
        footerTop: function () {
            var footer = document.getElementsByClassName('footer')[0]
            footer.style.marginTop = '-' + footer.scrollHeight + 'px'
        }
    },
    mounted: function () {
        this.footerTop()
    }
}
</script>

<style lang="scss" scoped>
.not-found {
    width: 100%;
    .content {
        position: relative;
        height: 100vh;
        text-align: center;
        p {
            display: block;
            position: absolute;
            top: 45%;
            left: 50%;
            font-weight: 700;
            color: #666;
            transform: translate(-50%, -50%);
            span {
                display: block;
                &:first-child {
                    font-size: 20px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/NotFound.vue